<script>
    import { Pie } from 'vue-chartjs';

    export default {
        extends: Pie,

        props: {
            stats: {
                type: Array,
                required: true,
            },
        },

        data: () => ({
            options: {},
        }),

        methods: {
            async chartData() {
                return {
                    labels: this.stats.map(row => row.value),
                    datasets: [
                        {
                            backgroundColor: this.stats.map(
                                row => `#${this.intToRGB(this.hashCode(row.value))}`,
                            ),
                            data: this.stats.map(row => Math.round((100 / row.total) * row.result)),
                        },
                    ],
                };
            },

            async update() {
                const data = await this.chartData();

                this.renderChart(
                    data,
                    {
                        aspectRatio: 4,
                        maintainAspectRatio: false,
                        legend: {
                            display: false,
                        },
                    },
                );
            },

            hashCode(str) {
                /* eslint-disable no-bitwise */
                let hash = 0;
                for (let i = 0; i < str.length; i += 1) {
                    hash = str.charCodeAt(i) + ((hash << 5) - hash);
                }
                return hash;
            },

            intToRGB(i) {
                const c = (i & 0x00FFFFFF)
                    .toString(16)
                    .toUpperCase();

                return '00000'.substring(0, 6 - c.length) + c;
            },
        },

        mounted() {
            this.update();
        },

        watch: {
            stats() {
                this.update();
            },
        },
    };
</script>
